export const MapperTypeImportLevel = {
	order_import: 10,
};

export const MapperTypeCompanyLevel = {
	none: 0,
	loading: 1,
	unloading: 2,
	loading_unloading_cc: 3,
	incoming_pallet_import: 4,
	outgoing_pallet_import: 5,
	...MapperTypeImportLevel,
};

export const MapperType = {
	...MapperTypeCompanyLevel,
};

export const outputDocumentsMapperTypes = [
	MapperType.loading,
	MapperType.unloading,
	MapperType.loading_unloading_cc,
];
